 
import { Link } from 'react-router-dom';
import { useEffect, useState } from "react";
import './header.css';
import logo from '../../assets/images/logo.png'; 


const Header = () => {

  const [isSinhala, setIsSinhala] = useState(false);
  const [isTamil, setIsTamil] = useState(false);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const el = document.querySelector(".nav-link");
      if (el && /[\u0D80-\u0DFF]/.test(el.innerText)) {
        setIsSinhala(true);
        console.log("Sinhala detected");
      } 
      else if  (el && /[\u0B80-\u0BFF]/.test(el.innerText)) {
        setIsTamil(true);
        console.log("Tamil detected");
      } 
      
      else {
        setIsSinhala(false);
        setIsTamil(false);
        console.log("Sinhala not detected");
      }
      
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    return () => observer.disconnect();
  }, []);

  const style_nav = {
    color: "#f94322",
    fontSize: isSinhala ? "12px" : isTamil ? "11px" : "21px",
   // fontSize: isTamil ? "12px" : "20px",
    fontFamily: isSinhala ? "'Noto Sans Sinhala', sans-serif" : "inherit",

   
    
  }; const cus_button = { fontSize:isTamil ? "11px" : isSinhala ? "18px" : "18px",};


    const [menuOpen, setMenuOpen] = useState(false);
    return (
        <nav className="navbar navbar-expand-lg sticky-top" style={{backgroundColor: "#ddf8f0", maxHeight: "65px" , fontFamily: "Helvetica Neue"}}>
             <div className="container">
              <Link className="navbar-brand" to="/">
              <img src={logo} alt="Logo" className="logo-img" /> </Link>
           
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation" >                
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarNav" style={style_nav}>
            <ul className="navbar-nav ms-auto" >
              <li className="nav-item me-3">
          <Link className="nav-link" to="/">
            Home
          </Link>
              </li>              
              <li className="nav-item dropdown me-3">
          <a className="nav-link dropdown-toggle" href="#" id="dropdown03" data-bs-toggle="dropdown" aria-expanded="false">Projects</a>
          <ul className="dropdown-menu" aria-labelledby="dropdown03">
              <li><Link className="nav-link" to="/prospective-projects">Prospective </Link></li>
              <li><Link className="nav-link" to="/ongoing-projects">Ongoing </Link></li>
              <li><Link className="nav-link" to="/vested-projects">Vested </Link></li>
          </ul>
          </li>
          <li className="nav-item dropdown me-3">
          <a className="nav-link dropdown-toggle" href="#" id="dropdown03" data-bs-toggle="dropdown" aria-expanded="false">Campaigns</a>
          <ul className="dropdown-menu" aria-labelledby="dropdown03">
              <li><Link className="nav-link" to="/gammadda-thaksalava">Gammadda Thaksalava </Link></li>
              <li><Link className="nav-link" to="/gammadda-nagitimu-sri-lanka">Nagitimu Sri Lanka </Link></li>
              <li><Link className="nav-link" to="/gammadda-smiles">Gammadda Smiles </Link></li>
              <li><Link className="nav-link" to="/educational-assistance-program">Educational Assistance Programe </Link></li>
          </ul>
          </li>
          <li className="nav-item dropdown me-3">
          <Link className="nav-link dropdown-toggle" to="/about" id="dropdown03" data-bs-toggle="dropdown" aria-expanded="false">Who We Are</Link>
          <ul className="dropdown-menu" aria-labelledby="dropdown03">
              <li><Link className="nav-link" to="/gammadda-universe">Our Universe </Link></li>                    
          </ul>
          </li>

              <li className="nav-item me-3">
          <Link className="nav-link" to="/research-and-data">
            Research
          </Link>
              </li>
              <li className="nav-item me-3">
          <Link className="nav-link" to="/latest-updates">
            Latest updates
          </Link>
              </li>
              <li className="nav-item dropdown me-3">
          <Link className="nav-link dropdown-toggle" to="/services" id="dropdown03" data-bs-toggle="dropdown" aria-expanded="false">Join US</Link>
          <ul className="dropdown-menu" aria-labelledby="dropdown03">
          <li><Link className="nav-link" to="/gammadda-partners">Partnership </Link></li>                    
          <li><Link className="nav-link" to="/gammadda-volunteering">Volunteer </Link></li>                    
          </ul>
          </li>
          <li className="nav-item me-5">
          <Link className="nav-link" to="/reach-out">
          Reach Out
          </Link>
              </li>
              <li className="nav-item me- " >
              <Link to="/make-a-donation" className="button donate-button" style={cus_button}>Donate</Link>
              </li>
              <li className="nav-item ms-auto" >
              
              </li>
            </ul>
          </div>
        </div>
            </nav>
    );
};

export default Header;